const initObjectsSlider = () => {
	const section = document.querySelector("section.objects");

	if (!section) {
		return;
	}

	const slider = section.querySelector(".objects-slider");

	const swiper = new Swiper(".objects", {
		slidesPerView: 1.1,
		spaceBetween: 8,
        loop: false,
        navigation: {
            nextEl: ".button-next",
            prevEl: ".button-prev",
        },

		breakpoints: {
			768: {
				slidesPerView: 1.5,
				spaceBetween: 20,
			},

			992: {
				slidesPerView: 2.7,
				spaceBetween: 20,
			},

			1440: {
				slidesPerView: 3.6,
				spaceBetween: 20,
			},
		},
	});
};

export { initObjectsSlider };
